import {Component} from 'react';
import PropTypes from 'prop-types';
import './TextMeasurer.scss';

const MEASURER_LINE_HEIGHT = 18;

export default class TextMeasurer extends Component {
  static propTypes = {
    text: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    width: PropTypes.number.isRequired,
    onLinesChange: PropTypes.func.isRequired,
  };

  state = {
    lines: null,
  };

  componentDidMount() {
    this.calculateFeaturedLines();
  }

  componentDidUpdate(prevProps) {
    if (this.props.text !== prevProps.text || this.props.width !== prevProps.width) {
      this.setState({lines: null});
      this.calculateFeaturedLines();
    }
  }

  calculateFeaturedLines = () => {
    const {onLinesChange} = this.props;
    const {lines} = this.state;

    if (this._measurer) {
      const newLines = Math.round(this._measurer.offsetHeight / MEASURER_LINE_HEIGHT);
      if (newLines !== lines) {
        onLinesChange(newLines);
        this.setState({lines: newLines});
      }
    }
  };

  render() {
    const {text, width} = this.props;

    if (!text) {
      return null;
    }

    return (
      <div className="TextMeasurer"
           style={{width: width}}
           ref={(ref) => this._measurer = ref}
           data-testid="text-measurer"
      >
        {`${text}`.trim()}
      </div>
    );
  }
}
